export default __webpack_public_path__ + "assets/png/12a1fde77dc5147e85e360ea919952cf.png";